import axios from "axios";
import { getAccessToken } from "./authSession";
import { API_BASE_URL } from "../config";

const getAuthHeaders = () => {
    const token = getAccessToken();
    if (!token) {
        window.location.href = "/";
        return {};
    }
    return {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    };
};

export const listCounterparties = async ({ query = "", limit = 200 } = {}) => {
    const response = await axios.get(`${API_BASE_URL}/counterparties`, {
        ...getAuthHeaders(),
        params: { query, limit },
    });
    return response.data;
};

export const createCounterparty = async (payload) => {
    const response = await axios.post(`${API_BASE_URL}/counterparties`, payload, getAuthHeaders());
    return response.data;
};

export const updateCounterparty = async (counterpartyId, payload) => {
    const response = await axios.put(`${API_BASE_URL}/counterparties/${counterpartyId}`, payload, getAuthHeaders());
    return response.data;
};

export const deleteCounterparty = async (counterpartyId) => {
    const response = await axios.delete(`${API_BASE_URL}/counterparties/${counterpartyId}`, getAuthHeaders());
    return response.data;
};

export const createCounterpartyAccount = async (counterpartyId, payload) => {
    const response = await axios.post(`${API_BASE_URL}/counterparties/${counterpartyId}/accounts`, payload, getAuthHeaders());
    return response.data;
};

export const deleteCounterpartyAccount = async (counterpartyId, accountId) => {
    const response = await axios.delete(
        `${API_BASE_URL}/counterparties/${counterpartyId}/accounts/${accountId}`,
        getAuthHeaders(),
    );
    return response.data;
};

export const upsertCounterpartyDropshipLink = async (counterpartyId, payload) => {
    const response = await axios.post(
        `${API_BASE_URL}/counterparties/${counterpartyId}/dropship-links`,
        payload,
        getAuthHeaders(),
    );
    return response.data;
};

export const deleteCounterpartyDropshipLink = async (counterpartyId, linkId) => {
    const response = await axios.delete(
        `${API_BASE_URL}/counterparties/${counterpartyId}/dropship-links/${linkId}`,
        getAuthHeaders(),
    );
    return response.data;
};

export const upsertCounterpartyWholesaleLink = async (counterpartyId, payload) => {
    const response = await axios.post(
        `${API_BASE_URL}/counterparties/${counterpartyId}/wholesale-links`,
        payload,
        getAuthHeaders(),
    );
    return response.data;
};

export const deleteCounterpartyWholesaleLink = async (counterpartyId, linkId) => {
    const response = await axios.delete(
        `${API_BASE_URL}/counterparties/${counterpartyId}/wholesale-links/${linkId}`,
        getAuthHeaders(),
    );
    return response.data;
};

export const listPaymentPlatforms = async ({ includeInactive = false } = {}) => {
    const response = await axios.get(`${API_BASE_URL}/payment-platforms`, {
        ...getAuthHeaders(),
        params: { include_inactive: includeInactive },
    });
    return response.data;
};

export const upsertCounterpartyPlatformLink = async (counterpartyId, payload) => {
    const response = await axios.post(
        `${API_BASE_URL}/counterparties/${counterpartyId}/platform-links`,
        payload,
        getAuthHeaders(),
    );
    return response.data;
};

export const deleteCounterpartyPlatformLink = async (counterpartyId, linkId) => {
    const response = await axios.delete(
        `${API_BASE_URL}/counterparties/${counterpartyId}/platform-links/${linkId}`,
        getAuthHeaders(),
    );
    return response.data;
};
